import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogTitle } from '@angular/material/dialog';

@Component({
    selector: 'app-manual-install-dialog-denied',
    standalone: true,
    imports: [
        MatButtonModule,
        MatDialogModule,
        MatDialogTitle,
    ],
    templateUrl: './manual-install-dialog-denied.component.html',
    styleUrl: './manual-install-dialog-denied.component.scss'
})
export class ManualInstallDialogDeniedComponent {

}
